var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObject},[_c('i',{class:_vm.iClassObject},[_vm._v(_vm._s(this.icon ? '' : _vm.index))]),_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('div',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }